<script setup lang="ts">
useHead({
    bodyAttrs: {
        class: 'text-gray-900',
    },
});
useRouteAnchorScroll();
</script>

<template>
    <div>
        <div class="flex min-h-screen bg-white">
            <div class="min-h-screen grow px-8">
                <header v-if="$slots.header">
                    <slot name="header" />
                    Notification
                </header>
                <main class="h-full max-w-full">
                    <NuxtLoadingIndicator
                        color="#142542"
                        :height="2"
                        class="shadow-lg"
                    />
                    <slot />
                </main>
            </div>
        </div>
        <JamBaseNotificationWrapper />
    </div>
</template>
